<script>
  import {mapActions, mapGetters} from 'vuex'

  let initialState = function () {
    return {
      specialty: null,
      exam: null
    }
  }

  export default {
    name: 'TreatmentSelector',

    props: ['isCompleted', 'isReady'],

    computed: {
      ...mapGetters(['getLabel', 'getTreatments', 'getExamData']),

      specialties: function () {
        let uniqueId = [];
        return this.getTreatments.filter(elem => {
          return !uniqueId.includes(elem.specialtyId) && uniqueId.push(elem.specialtyId);
        });
      },

      exams: function () {
        let specialityId = this.specialty && this.specialty.specialtyId;

        return !!specialityId ? this.getTreatments.filter(elem => elem.specialtyId == specialityId) : this.getTreatments;
      }
    },

    mounted: function () {
      let ctx = this;
      this.eventHub.$on("resetAll", event => {
        ctx.reset(true);
      });
    },

    methods: {
      ...mapActions(['completeStep', 'resetStepsTo', 'setExamData']),

      proceed: function () {
        this.$validator.validate().then(valid => {
          if (valid) {
            let exam = this.exam && this.exam.treatmentLabel;
            let specialty = this.specialty && this.specialty.specialtyLabel;

            this.setExamData({exam: exam, specialty: specialty});
            this.$analytics.pushEvent("prestazione:step-completed");
            this.completeStep(2);
          }
        });
      },

      reset: function (force) {
        if (force) {
          this.setExamData({
            exam: null,
            specialty: null
          });

          Object.assign(this.$data, initialState());
        } else {
          this.resetStepsTo(2);
        }
      },

      onChange: function () {
        this.exam = null;
      }
    },

    data: function () {
      return initialState()
    },
  }
</script>

<template>
  <div class="treatment-selector wrap-step" :class="{uncompleted : !isReady, checked : isCompleted}">
    <h4>
      <Msg id="ospedali.form.treatments.title"/>
    </h4>

    <div v-if="!isCompleted && isReady">
      <Msg class="help" id="ospedali.form.treatments.help"/>

      <div class="wrap-selects">
        <v-select v-model="specialty" :options="specialties" label="specialtyLabel" @input="onChange()"
                  :placeholder="getLabel('ospedali.form.treatments.specialties.select.default')">
          <span slot="no-options">
            {{getLabel('ospedali.form.empty.select')}}
          </span>
        </v-select>
        <div>
            <v-select v-model="exam" :options="exams" label="treatmentLabel" v-validate.disable="'required'"
                      :placeholder="getLabel('ospedali.form.treatments.exams.select.default')" data-vv-as=" "
                      :class="{ invalid: errors.has('exam')}" name="exam">
              <span slot="no-options">
                {{getLabel('ospedali.form.empty.select')}}
              </span>
            </v-select>
            <span class="error">{{ errors.first('exam') }}</span>
        </div>
      </div>

      <div class="wrap-main-cta">
        <button @click="proceed()" class="button-primary">
          {{getLabel('ospedali.form.button.proceeed')}}
        </button>
      </div>
    </div>

    <div v-else-if="isCompleted">
      <span>{{getExamData.exam}}</span>
      <button @click="reset(false)" class="button-text">{{getLabel("ospedali.form.button.modify")}}</button>
    </div>

  </div>
</template>